import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { initGA, trackPageView } from './utils/analytics';

// Pages
import Home from './components/Home';
import Landing from './pages/Landing';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import Products from './pages/Products';
import Orders from './pages/Orders';
import Settings from './pages/Settings';
import Subscription from './pages/Subscription';
import Onboarding from './pages/Onboarding';
import Chat from './pages/Chat';
import Calculator from './pages/Calculator';
import ProfitTracker from './pages/ProfitTracker';
import PredictiveAlerts from './pages/PredictiveAlerts';
import MoneyRecovery from './pages/MoneyRecovery';
import AmazonAds from './pages/AmazonAds';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';

// Components
import Layout from './components/Layout';
import PrivateRoute from './components/PrivateRoute';
import ErrorBoundary from './components/ErrorBoundary';

// Componente para trackear pageviews
function AnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    trackPageView(location.pathname + location.search);
  }, [location]);

  return null;
}

function App() {
  // Inicializar Google Analytics
  useEffect(() => {
    initGA();
  }, []);

  return (
    <ErrorBoundary>
      <AuthProvider>
        <Router>
          <AnalyticsTracker />
          <ErrorBoundary>
            <Routes>
              {/* Public routes */}
              <Route path="/" element={<Landing />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/privacy" element={<Privacy />} />
              
              {/* Onboarding (private but no layout) */}
              <Route path="/onboarding" element={<PrivateRoute><Onboarding /></PrivateRoute>} />
              
              {/* Private routes */}
              <Route element={<PrivateRoute><Layout /></PrivateRoute>}>
                <Route path="/dashboard" element={<ErrorBoundary><Dashboard /></ErrorBoundary>} />
                <Route path="/products" element={<ErrorBoundary><Products /></ErrorBoundary>} />
                <Route path="/orders" element={<ErrorBoundary><Orders /></ErrorBoundary>} />
                <Route path="/chat" element={<ErrorBoundary><Chat /></ErrorBoundary>} />
                <Route path="/calculator" element={<ErrorBoundary><Calculator /></ErrorBoundary>} />
                <Route path="/profit-tracker" element={<ErrorBoundary><ProfitTracker /></ErrorBoundary>} />
                <Route path="/predictive-alerts" element={<ErrorBoundary><PredictiveAlerts /></ErrorBoundary>} />
                <Route path="/money-recovery" element={<ErrorBoundary><MoneyRecovery /></ErrorBoundary>} />
                <Route path="/amazon-ads" element={<ErrorBoundary><AmazonAds /></ErrorBoundary>} />
                <Route path="/settings" element={<ErrorBoundary><Settings /></ErrorBoundary>} />
                <Route path="/subscription" element={<ErrorBoundary><Subscription /></ErrorBoundary>} />
              </Route>
            </Routes>
          </ErrorBoundary>
        </Router>
      </AuthProvider>
    </ErrorBoundary>
  );
}

export default App;
